// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogPageContentIntroStyles {
    contentWrapper?: InjectableCss;
    contentIntroText?: TypographyProps;
}

export const blogPageContentIntroStyles: BlogPageContentIntroStyles = {
    contentWrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(32))}
        `,
    },
    contentIntroText: {
        css: css`
            line-height: ${x => x.theme.design.typography.lineHeight.large};
            font-size: ${x => x.theme.design.typography.size.larger};
        `,
    },
};

const styles = blogPageContentIntroStyles;

const BlogPageContentIntro = ({ page }: Props) => {
    if (!page || !page.fields["blogIntro"]) {
        return null;
    }

    const {
        fields: { blogIntro },
    } = page;

    return (
        <StyledWrapper {...styles.contentWrapper}>
            <Typography {...styles.contentIntroText}>{parse(blogIntro, parserOptions)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogPageContentIntro),
    definition: {
        group: constants.widgetGroup.blogPage,
        allowedContexts: [constants.pageType.blogPost] as any,
    },
};

export default widgetModule;
